import { userLogin, phoneBind, getUserGraveList, updateWxName } from '@/api/user'
import { getToken, setToken } from '@/utils/auth'
import { setStore, getStore } from '@/utils/store'
const user = {
  state: {
    token: getToken(),
    userInfo: getStore({ name: 'userInfo' }) || {},
    openId: getStore({ name: 'openId' }) || {},
    phone: getStore({ name: 'phone' }) || '',
    mwList: getStore({ name: 'mwList' }) || {},
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER: (state, userInfo) => {
      state.userInfo = userInfo;
    },
    SET_OPENID: (state, openId) => {
      state.openId = openId;
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone;
    },
    SET_MWLIST: (state, mwList) => {
      state.mwList = mwList;
    },
  },

  actions: {
    // 登录
    Login ({ commit }, params) {
      return new Promise((resolve, reject) => {
        userLogin(params).then(res => {
          // console.log(res)
          commit('SET_PHONE', res.phone);
          setStore({ name: 'phone', content: res.phone })
          commit('SET_OPENID', res.open_id);
          setStore({ name: 'openId', content: res.open_id })
          commit("SET_USER", res);
          setStore({ name: 'userInfo', content: res })
          if (res.token) {
            setToken(res.token);
            commit('SET_TOKEN', res.token);
          }else{
            setToken('');
            commit('SET_TOKEN', '');
          }
          if (res.errcode){
            wx.closeWindow();
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 绑定手机号
    PhoneBind ({ commit }, data) {
      return new Promise((resolve, reject) => {
        phoneBind(data).then(res => {
          setToken(res.token);
          commit('SET_TOKEN', res.token);
          setStore({ name: 'phone', content: data.purePhoneNumber })
          commit('SET_PHONE', data.purePhoneNumber);
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetUserGraveList ({ commit }, data) {
      return new Promise((resolve, reject) => {
        getUserGraveList(data.pageNum, data.pageSize, data).then(res => {
          commit('SET_MWLIST', res.rows);
          setStore({ name: 'mwList', content: res.rows })
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateWxName ({ commit }, data){
      return new Promise((resolve, reject) => {
        updateWxName(data).then(() => {
          const info = {
            ...this.state.user.userInfo,
            headimgurl: data.avatar
          }
          commit('SET_USER', info);
          setStore({ name: 'userInfo', content: info })
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // // 获取用户信息
    // GetInfo({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     getInfo().then(res => {
    //       const user = res.user
    //       const avatar = (user.avatar == "" || user.avatar == null) ? require("@/assets/images/profile.jpg") : process.env.VUE_APP_BASE_API + user.avatar;
    //       if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
    //         commit('SET_ROLES', res.roles)
    //         commit('SET_PERMISSIONS', res.permissions)
    //       } else {
    //         commit('SET_ROLES', ['ROLE_DEFAULT'])
    //       }
    //       commit('SET_NAME', user.userName)
    //       commit('SET_AVATAR', avatar)
    //       commit("SET_USER", user);
    //       commit("SET_NICKNAME", user.nickName);
    //       resolve(res)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },


  }
}

export default user
